export default "__VITE_ASSET__CuaCl6J9__"